var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('tabs',{staticClass:" border-bottom pt-2",attrs:{"tabs":_vm.rutas}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }